export class HierarchySelector {
	static deselect(
		hierarchiesSelectedFormat: string[],
		selected: string[],
		cellUniqueId: string
	): string[] {
		const result: string[] = [];
		const cellUniqueIdParts = cellUniqueId.split("::");
		const rootPrefix = cellUniqueIdParts[0];

		for (const hierarchy of hierarchiesSelectedFormat) {
			if (!hierarchy.startsWith(rootPrefix)) continue;

			const hierarchyParts = hierarchy.split("::");
			let match = true;
			for (let i = 0; i < cellUniqueIdParts.length; i++) {
				if (hierarchyParts[i] !== cellUniqueIdParts[i]) {
					match = false;
					break;
				}
			}
			if (!match && selected.some((s) => hierarchy.startsWith(s + "::") || hierarchy === s))
				result.push(hierarchy); // "::" is necessary to prevent 01 from overlapping with 0; ie to prevent ROOT::pit1::0 matching ROOT::pit1::01, unless it matches exactly or is followed by additional hierarchy items
		}

		for (const hierarchy of selected) {
			if (!hierarchy.startsWith(rootPrefix)) result.push(hierarchy);
		}

		return result;
	}
}

// // ////  sample data/unit test inputs

// const hierarchiesSelectedFormat: string[] = [
//     "64c434bf0981ef59e96f51c5..ROOT::p3::pa1::hole2",
//     "64c434bf0981ef59e96f51c5..ROOT::p3::pa2::hole1",
//     "64c434bf0981ef59e96f51c5..ROOT::p4::pa2::hole1",
//     "64c434bf0981ef59e96f51c5..ROOT::pit1::pa1::hole1",
//     "64c434bf0981ef59e96f51c5..ROOT::pit1::pa1::hole2",
//     "64c434bf0981ef59e96f51c5..ROOT::pit1::pa2::hole1",
//     "64c434bf0981ef59e96f51c5..ROOT::pit2::pa1::hole1",
//     "64c434bf0981ef59e96f51c5..ROOT::pit2::pa1::hole2",
//     "64c4b8210981ef59e9703b5f..ROOT::p3::pa1::hole1",
//     "64c4b8210981ef59e9703b5f..ROOT::p3::pa1::hole2",
//     "64c4b8210981ef59e9703b5f..ROOT::p3::pa1::hole3",
//     "64c434bf0981ef59e96f51c5..ROOT::p3::pa1"
// ];

// const selected: string[] = ["64c434bf0981ef59e96f51c5..ROOT::pit1"];

// const cellUniqueId1 = "64c434bf0981ef59e96f51c5..ROOT::pit1::pa1::hole2";
// console.log(HierarchySelector.deselect(hierarchiesSelectedFormat, selected, cellUniqueId1)); // Output: ["64c434bf0981ef59e96f51c5..ROOT::pit1::pa1::hole1", "64c434bf0981ef59e96f51c5..ROOT::pit1::pa2::hole1"]

// const cellUniqueId2 = "64c434bf0981ef59e96f51c5..ROOT::pit1::pa1";
// console.log(HierarchySelector.deselect(hierarchiesSelectedFormat, selected, cellUniqueId2)); // Output: ["64c434bf0981ef59e96f51c5..ROOT::pit1::pa2::hole1"]

// const cellUniqueId3 = "64c434bf0981ef59e96f51c5..ROOT::pit1::pa2";
// console.log(HierarchySelector.deselect(hierarchiesSelectedFormat, selected, cellUniqueId3)); // Output: ["64c434bf0981ef59e96f51c5..ROOT::pit1::pa1::hole1", "64c434bf0981ef59e96f51c5..ROOT::pit1::pa1::hole2"]

// const cellUniqueId4 = "64c4b8210981ef59e9703b5f..ROOT::p3::pa1::hole2";
// const selected2 = ["64c4b8210981ef59e9703b5f..ROOT::p3", "64c434bf0981ef59e96f51c5..ROOT::p3::pa1"];
// console.log(HierarchySelector.deselect(hierarchiesSelectedFormat, selected2, cellUniqueId4)); // Output:["64c4b8210981ef59e9703b5f..ROOT::p3::pa1::hole1", "64c4b8210981ef59e9703b5f..ROOT::p3::pa1::hole3", "64c434bf0981ef59e96f51c5..ROOT::p3::pa1"]
